import React from 'react';

export interface IHostContext {
  firmId?: string;
  nodeId?: string;
}

export const HostContext = React.createContext<IHostContext>({});

export type IHostProviderProps = IHostContext;

export const HostProvider: React.FC<React.PropsWithChildren<IHostProviderProps>> = ({ firmId, nodeId, children }) => {
  const value = React.useMemo<IHostContext>(() => ({ firmId, nodeId }), [firmId, nodeId]);

  return <HostContext.Provider value={value}>{children}</HostContext.Provider>;
};

export const useHost = (): IHostContext => React.useContext(HostContext);
